import { render } from "./UiTabs.vue?vue&type=template&id=60482c52"
import script from "./UiTabs.vue?vue&type=script&lang=js"
export * from "./UiTabs.vue?vue&type=script&lang=js"

import "./UiTabs.vue?vue&type=style&index=0&id=60482c52&lang=css"

import exportComponent from "/home/runner/work/bot-v2/bot-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__